import * as bootstrap from "bootstrap";
import General from "./components/_general";
import Menu from "./components/_menu";
import Header from "./components/_header";
import Slider from "./components/_slider";
import Animate from "./components/_animate";
import Form from "./components/_form";
import Filter from "./components/_filter";

const App = {
  /**
   * App.init
   */
  init() {
    // General scripts
    function initGeneral() {
      return new General();
    }
    initGeneral();

    // Menu scripts
    function initMenu() {
      return new Menu();
    }
    initMenu();

    // Header scripts
    function initHeader() {
      return new Header();
    }
    initHeader();

    // Slider scripts
    function initSlider() {
      return new Slider();
    }
    initSlider();

    // Animate scripts
    function initAnimate() {
      return new Animate();
    }
    initAnimate();

    // Form scripts
    function initForm() {
      return new Form();
    }
    initForm();

    // Filter scripts
    function initFilter() {
      return new Filter();
    }
    initFilter();
  },
};

document.addEventListener("DOMContentLoaded", () => {
  App.init();
});
